const Tabs = () => {
  const screenWidth = window.innerWidth;
  const tabSections = [...document.querySelectorAll('.categories-menu .tab-section')];

  if (tabSections.length > 0) {
    tabSections.forEach(function (tabSection) {
      const tabsBtns = [...tabSection.querySelectorAll('.categories-menu .tab-btn')];
      const tabContents = [...tabSection.querySelectorAll('.categories-menu .tab-content')];
      
      if(tabsBtns && tabContents){
        tabsBtns[0].classList.add("active");
        tabContents[0].classList.add("active");

        tabsBtns.forEach(function (tabBtn) {
          tabBtn.addEventListener('click', function () {
            const tabId = tabBtn.getAttribute('data-tab');

            tabsBtns.forEach((b) => b.classList.remove("active"));
            tabContents.forEach((content) => content.classList.remove("active"));
        
            const selectedContent = tabSection.querySelector(`.categories-menu .tab-content[data-tab="${tabId}"]`);
        
            if (selectedContent) {
              selectedContent.classList.add("active");
              tabBtn.classList.add("active"); 

              // Only for categories menu
              const categoryLinks = [...selectedContent.querySelectorAll(".categories-menu .categories-menu__category-link")];
              const subcategoriesLists = [...document.querySelectorAll(".categories-menu .categories-menu__subcategories-lists")];

              const deactivateAllSubcategories = () => {
                subcategoriesLists.forEach((subcategoriesList) => {
                  subcategoriesList.classList.remove("active");
                });

                categoryLinks.forEach((categoryLink) => {
                  categoryLink.classList.remove("active");
                });
              };

              deactivateAllSubcategories();

              if (screenWidth > 1023 && categoryLinks.length > 0) {
                categoryLinks[0].classList.add("active");

                const selectedCategory = categoryLinks[0].dataset.category;
                
                const selectedSubcategoriesList = subcategoriesLists.find(
                  (subcategoriesList) => subcategoriesList.dataset.category === selectedCategory
                );

                if (selectedSubcategoriesList) {
                  selectedSubcategoriesList.classList.add("active");
                }
              }
              // 
            }
          });
        });
      }
    })
  }
}

export default Tabs